import { Trans, useTranslation } from "react-i18next";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { translateAnimalCategory, translateAnimalCategoryAge } from "../../../../i18n/translateAnimalCategory";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";

interface InfoSplitBatchProps {
  task: ITaskSplitBatch | undefined;
}


export default function InfoSplitBatch({ task: taskSplitBatch }: InfoSplitBatchProps) {
  const { t } = useTranslation();
  const isNewBatch = taskSplitBatch?.inventoryBatch_split_type === "Novo lote";
  const routeInitials = (taskSplitBatch?.destination_micro_area_route ?? [])
    .map(el => el.initials).join(", ");


  return (
    <>
      <div >
        <span><Trans i18nKey="taskDetails.onBatch" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AnimalsIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSplitBatch?.source_batch_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>


      <div className="containerQuestion">
        <MessageBalloon text={t("messageBalloon.createNewBatch")} pointed />
        <ButtonYesOrNo onlyResult optionSelected={isNewBatch ? "yes" : "no"} />
      </div>

      {isNewBatch ?
        <MessageBalloon text={t("messageBalloon.newBatchName", { name: taskSplitBatch?.destination_batch_initials ?? "" })} pointed />
        :
        <div >
          <span><Trans i18nKey="taskDetails.toBatch" /></span>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <AnimalsIcon width={30} className="iconInitialTaskInfo" />
            <div className="labelInitialTaskInfo">
              <span>{taskSplitBatch?.destination_batch_initials}</span>
              <PointIcon width={15} />
            </div>
          </div>
        </div>
      }

      {taskSplitBatch?.categories?.map((category, index) => (
        <div key={index}>
          <div className="lot__title--category" style={{ marginTop: 0 }}>{translateAnimalCategory(category.category_description.name, category.category_description.age_description)}</div>
          <div className="lot__subtitle--category">{translateAnimalCategoryAge(category.category_description.age_description, category.category_description.name)}</div>
          <CounterInputV2 name={`info-split-batch-qty-${index}`} value={Number(category.quantity ?? 0)} disabled />
        </div>
      ))}

      {isNewBatch && routeInitials &&
        <MessageBalloon text={t("messageBalloon.routePaddocks", { paddocks: routeInitials })} pointed />}
    </>
  )
}
